/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MediaReach,
    MediaReachFromJSON,
    MediaReachFromJSONTyped,
    MediaReachToJSON,
} from './MediaReach';

/**
 * 
 * @export
 * @interface GetAutoMediaListMediaOutletCountByTypeRequest
 */
export interface GetAutoMediaListMediaOutletCountByTypeRequest {
    /**
     * メディアリストのIDリスト
     * @type {Array<number>}
     * @memberof GetAutoMediaListMediaOutletCountByTypeRequest
     */
    mediaListIds?: Array<number>;
    /**
     * メディア種別のIDリスト
     * @type {Array<number>}
     * @memberof GetAutoMediaListMediaOutletCountByTypeRequest
     */
    mediaTypeIds: Array<number>;
    /**
     * 発行部数/PVのリスト
     * @type {Array<MediaReach>}
     * @memberof GetAutoMediaListMediaOutletCountByTypeRequest
     */
    reaches: Array<MediaReach>;
    /**
     * 検索キーワードリスト
     * @type {Array<string>}
     * @memberof GetAutoMediaListMediaOutletCountByTypeRequest
     */
    searchKeywords: Array<string>;
}

export function GetAutoMediaListMediaOutletCountByTypeRequestFromJSON(json: any): GetAutoMediaListMediaOutletCountByTypeRequest {
    return GetAutoMediaListMediaOutletCountByTypeRequestFromJSONTyped(json, false);
}

export function GetAutoMediaListMediaOutletCountByTypeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAutoMediaListMediaOutletCountByTypeRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mediaListIds': !exists(json, 'media_list_ids') ? undefined : json['media_list_ids'],
        'mediaTypeIds': json['media_type_ids'],
        'reaches': ((json['reaches'] as Array<any>).map(MediaReachFromJSON)),
        'searchKeywords': json['search_keywords'],
    };
}

export function GetAutoMediaListMediaOutletCountByTypeRequestToJSON(value?: GetAutoMediaListMediaOutletCountByTypeRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'media_list_ids': value.mediaListIds,
        'media_type_ids': value.mediaTypeIds,
        'reaches': ((value.reaches as Array<any>).map(MediaReachToJSON)),
        'search_keywords': value.searchKeywords,
    };
}

